
import type { StepData } from "./stepData";


export interface Order {
    id: number;
    orderDate: string;
    status: string;
    totalContractPrice: number;
    step_data: StepData;
    sync_status: string;
    sync_version?: number;
    last_modified?: string;
    marked_for_deletion?: string;
}


export interface SyncChanges {
    order_id: number;
    status: string;
    sync_stamp: string;
}

/**
 * Order class with static method to create instances from database rows
 */
export class OrderModel {
    /**
     * Transform a database row into an Order object
     * Handles type conversions and field name mapping
     */
    static fromRow(row: Record<string, any>): Order {
        return {
            id: row.id,
            orderDate: row.order_date,
            status: row.status,
            totalContractPrice: row.total_contract_price || 0,
            step_data: typeof row.step_data === 'string' ? JSON.parse(row.step_data) : row.step_data,
            sync_version: row.sync_version,
            sync_status: row.sync_status,
            last_modified: row.last_modified,
            marked_for_deletion: row.marked_for_deletion
        };
    }
}
